import { pxToRem, clsx, createThemedCssVarDefinitions } from "@creditornot/cb-utils";
import * as React from "react";
import { jsx } from "react/jsx-runtime";
import "./style.css";
const typographyCssNew = {
  /**
   * Used for short, important text or numerals, like brand content.
   */
  display: `
    font: var(--cb-font-weight-bold) var(--cb-font-size-title-xxlarge)/var(--cb-font-leading-small) var(--cb-font-family-brand);
    letter-spacing: var(--cb-font-tracking-medium);
    font-feature-settings: var(--cb-font-family-brand-font-feature-settings);
  `,
  /**
   * Used for page headings, like profile or settings.
   */
  largeTitle: `
    font: var(--cb-font-weight-bold) var(--cb-font-size-title-xlarge)/var(--cb-font-leading-small) var(--cb-font-family-brand);
    letter-spacing: var(--cb-font-tracking-medium);
    font-feature-settings: var(--cb-font-family-brand-font-feature-settings);
  `,
  /**
   * Used for page headings, like profile or settings.
   */
  title: `
    font: var(--cb-font-weight-bold) var(--cb-font-size-title-large)/var(--cb-font-leading-small) var(--cb-font-family-brand);
    letter-spacing: var(--cb-font-tracking-medium);
    font-feature-settings: var(--cb-font-family-brand-font-feature-settings);
  `,
  /**
   * Used to introduce new sections or in large components, like modals.
   */
  headline: `
    font: var(--cb-font-weight-semibold) var(--cb-font-size-title-medium)/var(--cb-font-leading-small) var(--cb-font-family-brand);
    letter-spacing: var(--cb-font-tracking-medium);
    font-feature-settings: var(--cb-font-family-brand-font-feature-settings);
  `,
  /**
   * Used to introduce subsections or in small components like banners.
   */
  subheadline: `
    font: var(--cb-font-weight-bold) var(--cb-font-size-body-medium)/var(--cb-font-leading-small) var(--cb-font-family-sans);
    letter-spacing: var(--cb-font-tracking-medium);
  `,
  /**
   * Default size for reading text.
   */
  body: `
    font: var(--cb-font-weight-regular) var(--cb-font-size-body-medium)/var(--cb-font-leading-medium) var(--cb-font-family-sans);
    letter-spacing: var(--cb-font-tracking-medium);
  `,
  /**
   * Used to style interactive labels or to emphasise text. It pairs with Body.
   */
  bodyLabel: `
    font: var(--cb-font-weight-semibold) var(--cb-font-size-body-medium)/var(--cb-font-leading-medium) var(--cb-font-family-sans);
    letter-spacing: var(--cb-font-tracking-medium);
  `,
  /**
   * Use for text links inside a paragraph or for standalone text. It pairs with Body.
   */
  bodyLink: `
    font: var(--cb-font-weight-semibold) var(--cb-font-size-body-medium)/var(--cb-font-leading-medium) var(--cb-font-family-sans);
    letter-spacing: var(--cb-font-tracking-medium);
    text-decoration: underline;
  `,
  /**
   * Used for short paragraph or helper text, like captions or metadata.
   */
  caption: `
    font: var(--cb-font-weight-regular) var(--cb-font-size-body-small)/var(--cb-font-leading-medium) var(--cb-font-family-sans);
    letter-spacing: var(--cb-font-tracking-medium);
  `,
  /**
   * Used to style interactive labels or to emphasise text. It pairs with Caption.
   */
  captionLabel: `
    font: var(--cb-font-weight-semibold) var(--cb-font-size-body-small)/var(--cb-font-leading-medium) var(--cb-font-family-sans);
    letter-spacing: var(--cb-font-tracking-medium);
  `,
  /**
   * Use for text links inside a paragraph or for standalone text. It pairs with Caption.
   */
  captionLink: `
    font: var(--cb-font-weight-semibold) var(--cb-font-size-body-small)/var(--cb-font-leading-medium) var(--cb-font-family-sans);
    letter-spacing: var(--cb-font-tracking-medium);
    text-decoration: underline;
  `,
  /**
   * Used for helper text or legal copy, like text that appears below an input field.
   */
  footnote: `
    font: var(--cb-font-weight-regular) var(--cb-font-size-footnote-medium)/var(--cb-font-leading-medium) var(--cb-font-family-sans);
    letter-spacing: var(--cb-font-tracking-large);
  `,
  /**
   * Used to style interactive labels or to emphasise text. It pairs with Footnote.
   */
  footnoteLabel: `
    font: var(--cb-font-weight-semibold) var(--cb-font-size-footnote-medium)/var(--cb-font-leading-medium) var(--cb-font-family-sans);
    letter-spacing: var(--cb-font-tracking-large);
  `,
  /**
   * Use for text links inside a paragraph or for standalone text. It pairs with Footnote.
   */
  footnoteLink: `
    font: var(--cb-font-weight-semibold) var(--cb-font-size-footnote-medium)/var(--cb-font-leading-medium) var(--cb-font-family-sans);
    letter-spacing: var(--cb-font-tracking-large);
    text-decoration: underline;
  `
};
const baseHeadingStyle$2 = `
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-variant-ligatures: common-ligatures;
  font-family: var(--cb-font-family-brand);
  font-feature-settings: var(--cb-font-family-brand-font-feature-settings);

`;
const baseBodyStyle$2 = `
  font-feature-settings: 'kern';
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-family: var(--cb-font-family-sans);
`;
const fontWeights$2 = {
  inherit: "inherit",
  normal: "400",
  semiBold: "500",
  bold: "700"
};
function decoratedFontStyle$2(cssStyle) {
  return ({
    disableNestedWeightTags,
    weight = "normal"
  } = {}) => {
    return `
      ${cssStyle}
      font-weight: ${fontWeights$2[weight]};

      ${disableNestedWeightTags ? "" : `
        b, strong {
          font-weight: ${weight === "bold" || weight === "semiBold" ? "700" : "600"};
        }
      `}
    `;
  };
}
const typographyCssOld = {
  /**
   * @deprecated This style is deprecated. If you still need to access the old text styles, please use `legacyToolsTypographyCss`.
   * Moreover, prefer using class based approach with `typographyClassName` for new features.
   */
  baseBodyStyle: () => baseBodyStyle$2,
  /**
   * @deprecated This style is deprecated. If you still need to access the old text styles, please use `legacyToolsTypographyCss`.
   * Moreover, prefer using class based approach with `typographyClassName` for new features.
   */
  baseHeadingStyle: () => baseHeadingStyle$2,
  /**
   * @deprecated This style is deprecated. If you still need to access the old text styles, please use `legacyToolsTypographyCss`.
   *
   * Possible replacement: `typographyClassName.display`.
   *
   * Moreover, prefer using class based approach with `typographyClassName` for new features.
   */
  Heading1: () => `
    ${baseHeadingStyle$2}
    font-size: ${pxToRem(48)};
    line-height: ${pxToRem(52)};
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    text-transform: none;
  `,
  /**
   * @deprecated This style is deprecated. If you still need to access the old text styles, please use `legacyToolsTypographyCss`.
   *
   * Possible replacement: `typographyClassName.display`.
   *
   * Moreover, prefer using class based approach with `typographyClassName` for new features.
   */
  Heading2: () => `
    ${baseHeadingStyle$2}
    font-size: ${pxToRem(40)};
    line-height: ${pxToRem(44)};
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    text-transform: none;
  `,
  /**
   * @deprecated This style is deprecated. If you still need to access the old text styles, please use `legacyToolsTypographyCss`.
   *
   * Possible replacement: `typographyClassName.largeTitle`.
   *
   * Moreover, prefer using class based approach with `typographyClassName` for new features.
   */
  Heading3: () => `
    ${baseHeadingStyle$2}
    font-size: ${pxToRem(32)};
    line-height: ${pxToRem(36)};
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    text-transform: none;
  `,
  /**
   * @deprecated This style is deprecated. If you still need to access the old text styles, please use `legacyToolsTypographyCss`.
   *
   * Possible replacement: `typographyClassName.largeTitle`.
   *
   * Moreover, prefer using class based approach with `typographyClassName` for new features.
   */
  Heading4: () => `
    ${baseHeadingStyle$2}
    font-size: ${pxToRem(28)};
    line-height: ${pxToRem(32)};
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    text-transform: none;
  `,
  /**
   * @deprecated This style is deprecated. If you still need to access the old text styles, please use `legacyToolsTypographyCss`.
   *
   * Possible replacement: `typographyClassName.title`.
   *
   * Moreover, prefer using class based approach with `typographyClassName` for new features.
   */
  Heading5: () => `
    ${baseHeadingStyle$2}
    font-size: ${pxToRem(24)};
    line-height: ${pxToRem(28)};
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    text-transform: none;
  `,
  /**
   * @deprecated This style is deprecated. If you still need to access the old text styles, please use `legacyToolsTypographyCss`.
   *
   * Possible replacement: `typographyClassName.headline`.
   *
   * Moreover, prefer using class based approach with `typographyClassName` for new features.
   */
  Heading6: () => `
    ${baseHeadingStyle$2}
    font-size: ${pxToRem(20)};
    line-height: ${pxToRem(24)};
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    text-transform: none;
  `,
  /**
   * @deprecated This style is deprecated. If you still need to access the old text styles, please use `legacyToolsTypographyCss`.
   *
   * Possible replacement: `typographyClassName.subheadline`.
   *
   * Moreover, prefer using class based approach with `typographyClassName` for new features.
   */
  Title1: () => `
    ${baseBodyStyle$2}
    font-size: ${pxToRem(16)};
    line-height: ${pxToRem(20)};
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
  `,
  /**
   * @deprecated This style is deprecated. If you still need to access the old text styles, please use `legacyToolsTypographyCss`.
   *
   * Possible replacement: `typographyClassName.captionLabel`.
   *
   * Moreover, prefer using class based approach with `typographyClassName` for new features.
   */
  Title2: () => `
    ${baseBodyStyle$2}
    font-size: ${pxToRem(14)};
    line-height: ${pxToRem(20)};
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
  `,
  /**
   * @deprecated This style is deprecated. If you still need to access the old text styles, please use `legacyToolsTypographyCss`.
   *
   * Possible replacement: `typographyClassName.footnoteLabel`.
   *
   * Moreover, prefer using class based approach with `typographyClassName` for new features.
   */
  Subtitle: () => `
    ${baseBodyStyle$2}
    font-size: ${pxToRem(12)};
    line-height: ${pxToRem(16)};
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
  `,
  /**
   * @deprecated This style is deprecated. If you still need to access the old text styles, please use `legacyToolsTypographyCss`.
   *
   * Possible replacement: `typographyClassName.body` or `typographyClassName.bodyLabel`.
   *
   * Moreover, prefer using class based approach with `typographyClassName` for new features.
   */
  Body1: decoratedFontStyle$2(`
    ${baseBodyStyle$2}
    font-size: ${pxToRem(18)};
    line-height: ${pxToRem(24)};
    font-style: normal;
    font-stretch: normal;
  `),
  /**
   * @deprecated This style is deprecated. If you still need to access the old text styles, please use `legacyToolsTypographyCss`.
   *
   * Possible replacement: `typographyClassName.body` or `typographyClassName.bodyLabel`.
   *
   * Moreover, prefer using class based approach with `typographyClassName` for new features.
   */
  Body2: decoratedFontStyle$2(`
    ${baseBodyStyle$2}
    font-size: ${pxToRem(16)};
    line-height: ${pxToRem(20)};
    font-style: normal;
    font-stretch: normal;
  `),
  /**
   * @deprecated This style is deprecated. If you still need to access the old text styles, please use `legacyToolsTypographyCss`.
   *
   * Possible replacement: `typographyClassName.caption` or `typographyClassName.captionLabel`.
   *
   * Moreover, prefer using class based approach with `typographyClassName` for new features.
   */
  Body3: decoratedFontStyle$2(`
    ${baseBodyStyle$2}
    font-size: ${pxToRem(14)};
    line-height: ${pxToRem(20)};
    font-style: normal;
    font-stretch: normal;
  `),
  /**
   * @deprecated This style is deprecated. If you still need to access the old text styles, please use `legacyToolsTypographyCss`.
   *
   * Possible replacement: `typographyClassName.footnote` or `typographyClassName.footnoteLabel`.
   *
   * Moreover, prefer using class based approach with `typographyClassName` for new features.
   */
  Small: decoratedFontStyle$2(`
    ${baseBodyStyle$2}
    font-size: ${pxToRem(12)};
    line-height: ${pxToRem(16)};
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
  `),
  /**
   * @deprecated This style is deprecated. If you still need to access the old text styles, please use `legacyToolsTypographyCss`.
   *
   * Possible replacement: `typographyClassName.footnote` or `typographyClassName.footnoteLabel`.
   *
   * Moreover, prefer using class based approach with `typographyClassName` for new features.
   */
  Tiny: decoratedFontStyle$2(`
    ${baseBodyStyle$2}
    font-size: ${pxToRem(10)};
    line-height: ${pxToRem(12)};
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
  `),
  /**
   * @deprecated This style is deprecated. If you still need to access the old text styles, please use `legacyToolsTypographyCss`.
   * Moreover, prefer using class based approach with `typographyClassName` for new features.
   */
  Overline1: () => `
    ${baseBodyStyle$2}
    text-transform: uppercase;
    font-size: ${pxToRem(16)};
    line-height: ${pxToRem(20)};
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
  `,
  /**
   * @deprecated This style is deprecated. If you still need to access the old text styles, please use `legacyToolsTypographyCss`.
   * Moreover, prefer using class based approach with `typographyClassName` for new features.
   */
  Overline2: () => `
    ${baseBodyStyle$2}
    text-transform: uppercase;
    font-size: ${pxToRem(14)};
    line-height: ${pxToRem(20)};
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
  `,
  /**
   * @deprecated This style is deprecated. If you still need to access the old text styles, please use `legacyToolsTypographyCss`.
   * Moreover, prefer using class based approach with `typographyClassName` for new features.
   */
  Overline3: () => `
    ${baseBodyStyle$2}
    text-transform: uppercase;
    font-size: ${pxToRem(12)};
    line-height: ${pxToRem(16)};
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
  `,
  /**
   * @deprecated This style is deprecated. If you still need to access the old text styles, please use `legacyToolsTypographyCss`.
   * Moreover, prefer using class based approach with `typographyClassName` for new features.
   */
  Overline4: () => `
    ${baseBodyStyle$2}
    text-transform: uppercase;
    font-size: ${pxToRem(10)};
    line-height: ${pxToRem(12)};
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
  `,
  /**
   * @deprecated This style is deprecated. If you still need to access the old text styles, please use `legacyToolsTypographyCss`.
   * Moreover, prefer using class based approach with `typographyClassName` for new features.
   */
  Quote1: () => `
    ${baseBodyStyle$2}
    font-size: ${pxToRem(16)};
    line-height: ${pxToRem(20)};
    font-weight: 500;
    font-style: italic;
    font-stretch: normal;
  `,
  /**
   * @deprecated This style is deprecated. If you still need to access the old text styles, please use `legacyToolsTypographyCss`.
   * Moreover, prefer using class based approach with `typographyClassName` for new features.
   */
  Quote2: () => `
    ${baseBodyStyle$2}
    font-size: ${pxToRem(14)};
    line-height: ${pxToRem(20)};
    font-weight: 500;
    font-style: italic;
    font-stretch: normal;
  `
};
const typographyCss = {
  ...typographyCssOld,
  ...typographyCssNew
};
const headingBase$1 = "cb_legacyTypographyClassName_headingBase_hntu";
const bodyBase$1 = "cb_legacyTypographyClassName_bodyBase_b95h";
const Heading1$1 = clsx(headingBase$1, "cb_legacyTypographyClassName_Heading1_hfkz");
const Heading2$1 = clsx(headingBase$1, "cb_legacyTypographyClassName_Heading2_h16g");
const Heading3$1 = clsx(headingBase$1, "cb_legacyTypographyClassName_Heading3_h16g");
const Heading4$1 = clsx(headingBase$1, "cb_legacyTypographyClassName_Heading4_h186");
const Heading5$1 = clsx(headingBase$1, "cb_legacyTypographyClassName_Heading5_h1og");
const Heading6$1 = clsx(headingBase$1, "cb_legacyTypographyClassName_Heading6_h5fj");
const Title1$1 = clsx(bodyBase$1, "cb_legacyTypographyClassName_Title1_t1g5");
const Title2$1 = clsx(bodyBase$1, "cb_legacyTypographyClassName_Title2_te9t");
const Subtitle$1 = clsx(bodyBase$1, "cb_legacyTypographyClassName_Subtitle_s1ve");
const Body1$1 = clsx(bodyBase$1, "cb_legacyTypographyClassName_Body1_b6sb");
const Body1SemiBold$1 = clsx(bodyBase$1, "cb_legacyTypographyClassName_Body1SemiBold_b1qt");
const Body1Bold$1 = clsx(bodyBase$1, "cb_legacyTypographyClassName_Body1Bold_b1ie");
const Body2$1 = clsx(bodyBase$1, "cb_legacyTypographyClassName_Body2_b40c");
const Body2SemiBold$1 = clsx(bodyBase$1, "cb_legacyTypographyClassName_Body2SemiBold_b19d");
const Body2Bold$1 = clsx(bodyBase$1, "cb_legacyTypographyClassName_Body2Bold_b136");
const Body3$1 = clsx(bodyBase$1, "cb_legacyTypographyClassName_Body3_bscf");
const Body3SemiBold$1 = clsx(bodyBase$1, "cb_legacyTypographyClassName_Body3SemiBold_bu5b");
const Body3Bold$1 = clsx(bodyBase$1, "cb_legacyTypographyClassName_Body3Bold_b1d2");
const Small$1 = clsx(bodyBase$1, "cb_legacyTypographyClassName_Small_s10s");
const SmallSemiBold$1 = clsx(bodyBase$1, "cb_legacyTypographyClassName_SmallSemiBold_s19l");
const SmallBold$1 = clsx(bodyBase$1, "cb_legacyTypographyClassName_SmallBold_s2jt");
const Tiny$1 = clsx(bodyBase$1, "cb_legacyTypographyClassName_Tiny_t1xl");
const TinySemiBold$1 = clsx(bodyBase$1, "cb_legacyTypographyClassName_TinySemiBold_tm99");
const TinyBold$1 = clsx(bodyBase$1, "cb_legacyTypographyClassName_TinyBold_t1i9");
const Overline1$1 = clsx(bodyBase$1, "cb_legacyTypographyClassName_Overline1_o1ut");
const Overline2$1 = clsx(bodyBase$1, "cb_legacyTypographyClassName_Overline2_o1cv");
const Overline3$1 = clsx(bodyBase$1, "cb_legacyTypographyClassName_Overline3_ou7y");
const Overline4$1 = clsx(bodyBase$1, "cb_legacyTypographyClassName_Overline4_o1sy");
const Quote1$1 = clsx(bodyBase$1, "cb_legacyTypographyClassName_Quote1_qrcm");
const Quote2$1 = clsx(bodyBase$1, "cb_legacyTypographyClassName_Quote2_q1fx");
const legacyTypographyClassNameAlias = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Body1: Body1$1,
  Body1Bold: Body1Bold$1,
  Body1SemiBold: Body1SemiBold$1,
  Body2: Body2$1,
  Body2Bold: Body2Bold$1,
  Body2SemiBold: Body2SemiBold$1,
  Body3: Body3$1,
  Body3Bold: Body3Bold$1,
  Body3SemiBold: Body3SemiBold$1,
  Heading1: Heading1$1,
  Heading2: Heading2$1,
  Heading3: Heading3$1,
  Heading4: Heading4$1,
  Heading5: Heading5$1,
  Heading6: Heading6$1,
  Overline1: Overline1$1,
  Overline2: Overline2$1,
  Overline3: Overline3$1,
  Overline4: Overline4$1,
  Quote1: Quote1$1,
  Quote2: Quote2$1,
  Small: Small$1,
  SmallBold: SmallBold$1,
  SmallSemiBold: SmallSemiBold$1,
  Subtitle: Subtitle$1,
  Tiny: Tiny$1,
  TinyBold: TinyBold$1,
  TinySemiBold: TinySemiBold$1,
  Title1: Title1$1,
  Title2: Title2$1,
  bodyBase: bodyBase$1,
  headingBase: headingBase$1
}, Symbol.toStringTag, { value: "Module" }));
const display = "cb_typographyClassNameNew_display_d15c";
const largeTitle = "cb_typographyClassNameNew_largeTitle_lhdo";
const title = "cb_typographyClassNameNew_title_t1ap";
const headline = "cb_typographyClassNameNew_headline_hcr9";
const subheadline = "cb_typographyClassNameNew_subheadline_s1hv";
const body = "cb_typographyClassNameNew_body_b1uq";
const bodyLabel = "cb_typographyClassNameNew_bodyLabel_b33d";
const bodyLink = "cb_typographyClassNameNew_bodyLink_b1kj";
const caption = "cb_typographyClassNameNew_caption_corr";
const captionLabel = "cb_typographyClassNameNew_captionLabel_c18i";
const captionLink = "cb_typographyClassNameNew_captionLink_cp16";
const footnote = "cb_typographyClassNameNew_footnote_f5w2";
const footnoteLabel = "cb_typographyClassNameNew_footnoteLabel_flyo";
const footnoteLink = "cb_typographyClassNameNew_footnoteLink_fuel";
const headingBase = "cb_typographyClassName_headingBase_h12y";
const bodyBase = "cb_typographyClassName_bodyBase_b1fq";
const Heading1 = clsx(headingBase, "cb_typographyClassName_Heading1_hgk2");
const Heading2 = clsx(headingBase, "cb_typographyClassName_Heading2_h2wt");
const Heading3 = clsx(headingBase, "cb_typographyClassName_Heading3_h1m1");
const Heading4 = clsx(headingBase, "cb_typographyClassName_Heading4_h1ho");
const Heading5 = clsx(headingBase, "cb_typographyClassName_Heading5_h1mw");
const Heading6 = clsx(headingBase, "cb_typographyClassName_Heading6_h1um");
const Title1 = clsx(bodyBase, "cb_typographyClassName_Title1_twf9");
const Title2 = clsx(bodyBase, "cb_typographyClassName_Title2_t71u");
const Subtitle = clsx(bodyBase, "cb_typographyClassName_Subtitle_shpc");
const Body1 = clsx(bodyBase, "cb_typographyClassName_Body1_b1rw");
const Body1SemiBold = clsx(bodyBase, "cb_typographyClassName_Body1SemiBold_b1ni");
const Body1Bold = clsx(bodyBase, "cb_typographyClassName_Body1Bold_bp0d");
const Body2 = clsx(bodyBase, "cb_typographyClassName_Body2_b1c4");
const Body2SemiBold = clsx(bodyBase, "cb_typographyClassName_Body2SemiBold_buez");
const Body2Bold = clsx(bodyBase, "cb_typographyClassName_Body2Bold_b1hh");
const Body3 = clsx(bodyBase, "cb_typographyClassName_Body3_b1dm");
const Body3SemiBold = clsx(bodyBase, "cb_typographyClassName_Body3SemiBold_b5z0");
const Body3Bold = clsx(bodyBase, "cb_typographyClassName_Body3Bold_b1mt");
const Small = clsx(bodyBase, "cb_typographyClassName_Small_sltz");
const SmallSemiBold = clsx(bodyBase, "cb_typographyClassName_SmallSemiBold_s1sf");
const SmallBold = clsx(bodyBase, "cb_typographyClassName_SmallBold_sltg");
const Tiny = clsx(bodyBase, "cb_typographyClassName_Tiny_t1ux");
const TinySemiBold = clsx(bodyBase, "cb_typographyClassName_TinySemiBold_t1yr");
const TinyBold = clsx(bodyBase, "cb_typographyClassName_TinyBold_t1q9");
const Overline1 = clsx(bodyBase, "cb_typographyClassName_Overline1_o7bb");
const Overline2 = clsx(bodyBase, "cb_typographyClassName_Overline2_o1mk");
const Overline3 = clsx(bodyBase, "cb_typographyClassName_Overline3_o1yg");
const Overline4 = clsx(bodyBase, "cb_typographyClassName_Overline4_o5u0");
const Quote1 = clsx(bodyBase, "cb_typographyClassName_Quote1_qkdg");
const Quote2 = clsx(bodyBase, "cb_typographyClassName_Quote2_qqny");
const typographyClassName = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Body1,
  Body1Bold,
  Body1SemiBold,
  Body2,
  Body2Bold,
  Body2SemiBold,
  Body3,
  Body3Bold,
  Body3SemiBold,
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  Heading5,
  Heading6,
  Overline1,
  Overline2,
  Overline3,
  Overline4,
  Quote1,
  Quote2,
  Small,
  SmallBold,
  SmallSemiBold,
  Subtitle,
  Tiny,
  TinyBold,
  TinySemiBold,
  Title1,
  Title2,
  body,
  bodyBase,
  bodyLabel,
  bodyLink,
  caption,
  captionLabel,
  captionLink,
  display,
  footnote,
  footnoteLabel,
  footnoteLink,
  headingBase,
  headline,
  largeTitle,
  subheadline,
  title
}, Symbol.toStringTag, { value: "Module" }));
const viewportWidth = {
  small: {
    min: 0,
    max: 767
  },
  medium: {
    min: 768,
    max: 1399
  },
  large: {
    min: 1400,
    max: Infinity
  }
};
const mediaQuery = {
  small: {
    /**
     * Small viewports: 0px - 767px
     */
    down: `@media screen and (max-width: ${viewportWidth.small.max}px)`
  },
  medium: {
    /**
     * Medium and small viewports: 0px - 1399px
     */
    down: `@media screen and (max-width: ${viewportWidth.medium.max}px)`,
    /**
     * Medium viewport: 768px - 1399px
     */
    only: `@media screen and (min-width: ${viewportWidth.medium.min}px) and (max-width: ${viewportWidth.medium.max}px)`,
    /**
     * Medium and large viewports: 768px and larger
     */
    up: `@media screen and (min-width: ${viewportWidth.medium.min}px)`
  },
  large: {
    /**
     * Large viewport: 1400px and larger
     */
    up: `@media screen and (min-width: ${viewportWidth.large.min}px)`
  }
};
const baseHeadingStyle$1 = typographyCss.baseHeadingStyle();
const baseBodyStyle$1 = typographyCss.baseBodyStyle();
const fontWeights$1 = {
  normal: 400,
  semiBold: 500,
  bold: 700
};
function decoratedFontStyle$1(cssStyle) {
  return ({
    disableNestedWeightTags,
    weight = "normal"
  } = {}) => {
    return `
      ${cssStyle}
      font-weight: ${fontWeights$1[weight]};

      ${disableNestedWeightTags ? "" : `
        b, strong {
          font-weight: ${weight === "semiBold" || weight === "bold" ? "700" : "600"};
        }`}
    `;
  };
}
const legacyConsumerTypographyCss = {
  HeadingExtraLarge: () => `
    ${baseHeadingStyle$1}
    font-size: ${pxToRem(60)};
    line-height: ${pxToRem(69)};
    font-weight: 700;
    font-style: normal;
    font-stretch: normal;
    text-transform: none;
  `,
  HeadingLarge: () => `
    ${baseHeadingStyle$1}
    font-size: ${pxToRem(46)};
    line-height: ${pxToRem(56)};
    font-weight: 700;
    font-style: normal;
    font-stretch: normal;
    text-transform: none;
  `,
  HeadingMedium: () => `
    ${baseHeadingStyle$1}
    font-size: ${pxToRem(32)};
    line-height: ${pxToRem(40)};
    font-weight: 700;
    font-style: normal;
    font-stretch: normal;
    text-transform: none;
  `,
  HeadingSmall: () => `
    ${baseHeadingStyle$1}
    font-size: ${pxToRem(28)};
    line-height: ${pxToRem(36)};
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    text-transform: none;
  `,
  HeadingTiny: () => `
    ${baseHeadingStyle$1}
    font-size: ${pxToRem(20)};
    line-height: ${pxToRem(24)};
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    text-transform: none;
  `,
  Body1: decoratedFontStyle$1(`
    ${baseBodyStyle$1}
    font-size: ${pxToRem(18)};
    line-height: ${pxToRem(24)};
    font-style: normal;
    font-stretch: normal;
    text-transform: none;
  `),
  Body2: decoratedFontStyle$1(`
    ${baseBodyStyle$1}
    font-size: ${pxToRem(16)};
    line-height: ${pxToRem(24)};
    font-style: normal;
    font-stretch: normal;
    text-transform: none;
  `),
  Body3: decoratedFontStyle$1(`
    ${baseBodyStyle$1}
    font-size: ${pxToRem(14)};
    line-height: ${pxToRem(20)};
    font-style: normal;
    font-stretch: normal;
    text-transform: none;
  `),
  Small: decoratedFontStyle$1(`
    ${baseBodyStyle$1}
    font-size: ${pxToRem(12)};
    line-height: ${pxToRem(16)};
    font-style: normal;
    font-stretch: normal;
    text-transform: none;
  `),
  Tiny: decoratedFontStyle$1(`
    ${baseBodyStyle$1}
    font-size: ${pxToRem(10)};
    line-height: ${pxToRem(12)};
    font-style: normal;
    font-stretch: normal;
    text-transform: none;
  `),
  Overline1: () => `
    ${baseBodyStyle$1}
    font-weight: 500;
    font-size: ${pxToRem(16)};
    line-height: ${pxToRem(20)};
    letter-spacing: ${pxToRem(0.5)};
    text-transform: uppercase;
  `,
  Overline2: () => `
    ${baseBodyStyle$1}
    font-weight: 500;
    font-size: ${pxToRem(14)};
    line-height: ${pxToRem(20)};
    letter-spacing: ${pxToRem(0.5)};
    font-style: normal;
    font-stretch: normal;
    text-transform: uppercase;
  `,
  Overline3: () => `
    ${baseBodyStyle$1}
    font-weight: 500;
    font-size: ${pxToRem(12)};
    line-height: ${pxToRem(16)};
    letter-spacing: ${pxToRem(0.5)};
    font-style: normal;
    font-stretch: normal;
    text-transform: uppercase;
  `,
  Overline4: () => `
    ${baseBodyStyle$1}
    font-weight: 500;
    font-size: ${pxToRem(10)};
    line-height: ${pxToRem(12)};
    letter-spacing: ${pxToRem(0.5)};
    font-style: normal;
    font-stretch: normal;
    text-transform: uppercase;
  `
};
const baseHeadingStyle = `
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-variant-ligatures: common-ligatures;
  font-family: var(--cb-font-family-brand);
  font-feature-settings: var(--cb-font-family-brand-font-feature-settings);
`;
const baseBodyStyle = `
  font-feature-settings: 'kern';
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-family: var(--cb-font-family-sans);
`;
const fontWeights = {
  inherit: "inherit",
  normal: "400",
  semiBold: "500",
  bold: "700"
};
function decoratedFontStyle(cssStyle) {
  return ({
    disableNestedWeightTags,
    weight = "normal"
  } = {}) => {
    return `
      ${cssStyle}
      font-weight: ${fontWeights[weight]};

      ${disableNestedWeightTags ? "" : `
        b, strong {
          font-weight: ${weight === "bold" || weight === "semiBold" ? "700" : "600"};
        }
      `}
    `;
  };
}
const legacyToolsTypographyCss = {
  baseBodyStyle: () => baseBodyStyle,
  baseHeadingStyle: () => baseHeadingStyle,
  Heading1: () => `
    ${baseHeadingStyle}
    font-size: ${pxToRem(48)};
    line-height: ${pxToRem(52)};
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    text-transform: none;
  `,
  Heading2: () => `
    ${baseHeadingStyle}
    font-size: ${pxToRem(40)};
    line-height: ${pxToRem(44)};
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    text-transform: none;
  `,
  Heading3: () => `
    ${baseHeadingStyle}
    font-size: ${pxToRem(32)};
    line-height: ${pxToRem(36)};
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    text-transform: none;
  `,
  Heading4: () => `
    ${baseHeadingStyle}
    font-size: ${pxToRem(28)};
    line-height: ${pxToRem(32)};
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    text-transform: none;
  `,
  Heading5: () => `
    ${baseHeadingStyle}
    font-size: ${pxToRem(24)};
    line-height: ${pxToRem(28)};
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    text-transform: none;
  `,
  Heading6: () => `
    ${baseHeadingStyle}
    font-size: ${pxToRem(20)};
    line-height: ${pxToRem(24)};
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    text-transform: none;
  `,
  Title1: () => `
    ${baseBodyStyle}
    font-size: ${pxToRem(16)};
    line-height: ${pxToRem(20)};
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
  `,
  Title2: () => `
    ${baseBodyStyle}
    font-size: ${pxToRem(14)};
    line-height: ${pxToRem(20)};
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
  `,
  Subtitle: () => `
    ${baseBodyStyle}
    font-size: ${pxToRem(12)};
    line-height: ${pxToRem(16)};
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
  `,
  Body1: decoratedFontStyle(`
    ${baseBodyStyle}
    font-size: ${pxToRem(18)};
    line-height: ${pxToRem(24)};
    font-style: normal;
    font-stretch: normal;
  `),
  Body2: decoratedFontStyle(`
    ${baseBodyStyle}
    font-size: ${pxToRem(16)};
    line-height: ${pxToRem(20)};
    font-style: normal;
    font-stretch: normal;
  `),
  Body3: decoratedFontStyle(`
    ${baseBodyStyle}
    font-size: ${pxToRem(14)};
    line-height: ${pxToRem(20)};
    font-style: normal;
    font-stretch: normal;
  `),
  Small: decoratedFontStyle(`
    ${baseBodyStyle}
    font-size: ${pxToRem(12)};
    line-height: ${pxToRem(16)};
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
  `),
  Tiny: decoratedFontStyle(`
    ${baseBodyStyle}
    font-size: ${pxToRem(10)};
    line-height: ${pxToRem(12)};
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
  `),
  Overline1: () => `
    ${baseBodyStyle}
    text-transform: uppercase;
    font-size: ${pxToRem(16)};
    line-height: ${pxToRem(20)};
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
  `,
  Overline2: () => `
    ${baseBodyStyle}
    text-transform: uppercase;
    font-size: ${pxToRem(14)};
    line-height: ${pxToRem(20)};
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
  `,
  Overline3: () => `
    ${baseBodyStyle}
    text-transform: uppercase;
    font-size: ${pxToRem(12)};
    line-height: ${pxToRem(16)};
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
  `,
  Overline4: () => `
    ${baseBodyStyle}
    text-transform: uppercase;
    font-size: ${pxToRem(10)};
    line-height: ${pxToRem(12)};
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
  `,
  Quote1: () => `
    ${baseBodyStyle}
    font-size: ${pxToRem(16)};
    line-height: ${pxToRem(20)};
    font-weight: 500;
    font-style: italic;
    font-stretch: normal;
  `,
  Quote2: () => `
    ${baseBodyStyle}
    font-size: ${pxToRem(14)};
    line-height: ${pxToRem(20)};
    font-weight: 500;
    font-style: italic;
    font-stretch: normal;
  `
};
const colors = {
  wolt100: "rgba(0, 157, 224, 1)",
  wolt96: "rgba(0, 157, 224, 0.96)",
  wolt92: "rgba(0, 157, 224, 0.92)",
  wolt88: "rgba(0, 157, 224, 0.88)",
  wolt84: "rgba(0, 157, 224, 0.84)",
  wolt80: "rgba(0, 157, 224, 0.80)",
  wolt76: "rgba(0, 157, 224, 0.76)",
  wolt72: "rgba(0, 157, 224, 0.72)",
  wolt68: "rgba(0, 157, 224, 0.68)",
  wolt64: "rgba(0, 157, 224, 0.64)",
  wolt60: "rgba(0, 157, 224, 0.60)",
  wolt56: "rgba(0, 157, 224, 0.56)",
  wolt52: "rgba(0, 157, 224, 0.52)",
  wolt48: "rgba(0, 157, 224, 0.48)",
  wolt44: "rgba(0, 157, 224, 0.44)",
  wolt40: "rgba(0, 157, 224, 0.40)",
  wolt36: "rgba(0, 157, 224, 0.36)",
  wolt32: "rgba(0, 157, 224, 0.32)",
  wolt28: "rgba(0, 157, 224, 0.28)",
  wolt24: "rgba(0, 157, 224, 0.24)",
  wolt20: "rgba(0, 157, 224, 0.20)",
  wolt16: "rgba(0, 157, 224, 0.16)",
  wolt12: "rgba(0, 157, 224, 0.12)",
  wolt8: "rgba(0, 157, 224, 0.08)",
  wolt4: "rgba(0, 157, 224, 0.04)",
  pepper100: "rgba(32, 33, 37, 1)",
  pepper96: "rgba(32, 33, 37, 0.96)",
  pepper92: "rgba(32, 33, 37, 0.92)",
  pepper88: "rgba(32, 33, 37, 0.88)",
  pepper84: "rgba(32, 33, 37, 0.84)",
  pepper80: "rgba(32, 33, 37, 0.80)",
  pepper76: "rgba(32, 33, 37, 0.76)",
  pepper72: "rgba(32, 33, 37, 0.72)",
  pepper68: "rgba(32, 33, 37, 0.68)",
  pepper64: "rgba(32, 33, 37, 0.64)",
  pepper60: "rgba(32, 33, 37, 0.60)",
  pepper56: "rgba(32, 33, 37, 0.56)",
  pepper52: "rgba(32, 33, 37, 0.52)",
  pepper48: "rgba(32, 33, 37, 0.48)",
  pepper44: "rgba(32, 33, 37, 0.44)",
  pepper40: "rgba(32, 33, 37, 0.40)",
  pepper36: "rgba(32, 33, 37, 0.36)",
  pepper32: "rgba(32, 33, 37, 0.32)",
  pepper28: "rgba(32, 33, 37, 0.28)",
  pepper24: "rgba(32, 33, 37, 0.24)",
  pepper20: "rgba(32, 33, 37, 0.20)",
  pepper16: "rgba(32, 33, 37, 0.16)",
  pepper12: "rgba(32, 33, 37, 0.12)",
  pepper8: "rgba(32, 33, 37, 0.08)",
  pepper4: "rgba(32, 33, 37, 0.04)",
  pepper2: "rgba(32, 33, 37, 0.02)",
  salt100: "rgba(255, 255, 255, 1)",
  salt96: "rgba(255, 255, 255, 0.96)",
  salt92: "rgba(255, 255, 255, 0.92)",
  salt88: "rgba(255, 255, 255, 0.88)",
  salt84: "rgba(255, 255, 255, 0.84)",
  salt80: "rgba(255, 255, 255, 0.80)",
  salt76: "rgba(255, 255, 255, 0.76)",
  salt72: "rgba(255, 255, 255, 0.72)",
  salt68: "rgba(255, 255, 255, 0.68)",
  salt64: "rgba(255, 255, 255, 0.64)",
  salt60: "rgba(255, 255, 255, 0.60)",
  salt56: "rgba(255, 255, 255, 0.56)",
  salt52: "rgba(255, 255, 255, 0.52)",
  salt48: "rgba(255, 255, 255, 0.48)",
  salt44: "rgba(255, 255, 255, 0.44)",
  salt40: "rgba(255, 255, 255, 0.40)",
  salt36: "rgba(255, 255, 255, 0.36)",
  salt32: "rgba(255, 255, 255, 0.32)",
  salt28: "rgba(255, 255, 255, 0.28)",
  salt24: "rgba(255, 255, 255, 0.24)",
  salt20: "rgba(255, 255, 255, 0.20)",
  salt16: "rgba(255, 255, 255, 0.16)",
  salt12: "rgba(255, 255, 255, 0.12)",
  salt8: "rgba(255, 255, 255, 0.08)",
  salt4: "rgba(255, 255, 255, 0.04)",
  darkSky100: "rgba(0, 120, 212, 1)",
  darkSky96: "rgba(0, 120, 212, 0.96)",
  darkSky92: "rgba(0, 120, 212, 0.92)",
  darkSky88: "rgba(0, 120, 212, 0.88)",
  darkSky84: "rgba(0, 120, 212, 0.84)",
  darkSky80: "rgba(0, 120, 212, 0.80)",
  darkSky76: "rgba(0, 120, 212, 0.76)",
  darkSky72: "rgba(0, 120, 212, 0.72)",
  darkSky68: "rgba(0, 120, 212, 0.68)",
  darkSky64: "rgba(0, 120, 212, 0.64)",
  darkSky60: "rgba(0, 120, 212, 0.60)",
  darkSky56: "rgba(0, 120, 212, 0.56)",
  darkSky52: "rgba(0, 120, 212, 0.52)",
  darkSky48: "rgba(0, 120, 212, 0.48)",
  darkSky44: "rgba(0, 120, 212, 0.44)",
  darkSky40: "rgba(0, 120, 212, 0.40)",
  darkSky36: "rgba(0, 120, 212, 0.36)",
  darkSky32: "rgba(0, 120, 212, 0.32)",
  darkSky28: "rgba(0, 120, 212, 0.28)",
  darkSky24: "rgba(0, 120, 212, 0.24)",
  darkSky20: "rgba(0, 120, 212, 0.20)",
  darkSky16: "rgba(0, 120, 212, 0.16)",
  darkSky12: "rgba(0, 120, 212, 0.12)",
  darkSky8: "rgba(0, 120, 212, 0.08)",
  darkSky4: "rgba(0, 120, 212, 0.04)",
  nightSky100: "rgba(15, 37, 148, 1)",
  nightSky96: "rgba(15, 37, 148, 0.96)",
  nightSky92: "rgba(15, 37, 148, 0.92)",
  nightSky88: "rgba(15, 37, 148, 0.88)",
  nightSky84: "rgba(15, 37, 148, 0.84)",
  nightSky80: "rgba(15, 37, 148, 0.80)",
  nightSky76: "rgba(15, 37, 148, 0.76)",
  nightSky72: "rgba(15, 37, 148, 0.72)",
  nightSky68: "rgba(15, 37, 148, 0.68)",
  nightSky64: "rgba(15, 37, 148, 0.64)",
  nightSky60: "rgba(15, 37, 148, 0.60)",
  nightSky56: "rgba(15, 37, 148, 0.56)",
  nightSky52: "rgba(15, 37, 148, 0.52)",
  nightSky48: "rgba(15, 37, 148, 0.48)",
  nightSky44: "rgba(15, 37, 148, 0.44)",
  nightSky40: "rgba(15, 37, 148, 0.40)",
  nightSky36: "rgba(15, 37, 148, 0.36)",
  nightSky32: "rgba(15, 37, 148, 0.32)",
  nightSky28: "rgba(15, 37, 148, 0.28)",
  nightSky24: "rgba(15, 37, 148, 0.24)",
  nightSky20: "rgba(15, 37, 148, 0.20)",
  nightSky16: "rgba(15, 37, 148, 0.16)",
  nightSky12: "rgba(15, 37, 148, 0.12)",
  nightSky8: "rgba(15, 37, 148, 0.08)",
  nightSky4: "rgba(15, 37, 148, 0.04)",
  space100: "rgba(0,0,0, 1)",
  space96: "rgba(0,0,0, 0.96)",
  space92: "rgba(0,0,0, 0.92)",
  space88: "rgba(0,0,0, 0.88)",
  space84: "rgba(0,0,0, 0.84)",
  space80: "rgba(0,0,0, 0.80)",
  space76: "rgba(0,0,0, 0.76)",
  space72: "rgba(0,0,0, 0.72)",
  space68: "rgba(0,0,0, 0.68)",
  space64: "rgba(0,0,0, 0.64)",
  space60: "rgba(0,0,0, 0.60)",
  space56: "rgba(0,0,0, 0.56)",
  space52: "rgba(0,0,0, 0.52)",
  space48: "rgba(0,0,0, 0.48)",
  space44: "rgba(0,0,0, 0.44)",
  space40: "rgba(0,0,0, 0.40)",
  space36: "rgba(0,0,0, 0.36)",
  space32: "rgba(0,0,0, 0.32)",
  space28: "rgba(0,0,0, 0.28)",
  space24: "rgba(0,0,0, 0.24)",
  space20: "rgba(0,0,0, 0.20)",
  space16: "rgba(0,0,0, 0.16)",
  space12: "rgba(0,0,0, 0.12)",
  space8: "rgba(0,0,0, 0.08)",
  space4: "rgba(0,0,0, 0.04)",
  lime100: "rgba(31, 199, 10, 1)",
  lime96: "rgba(31, 199, 10, 0.96)",
  lime92: "rgba(31, 199, 10, 0.92)",
  lime88: "rgba(31, 199, 10, 0.88)",
  lime84: "rgba(31, 199, 10, 0.84)",
  lime80: "rgba(31, 199, 10, 0.80)",
  lime76: "rgba(31, 199, 10, 0.76)",
  lime72: "rgba(31, 199, 10, 0.72)",
  lime68: "rgba(31, 199, 10, 0.68)",
  lime64: "rgba(31, 199, 10, 0.64)",
  lime60: "rgba(31, 199, 10, 0.60)",
  lime56: "rgba(31, 199, 10, 0.56)",
  lime52: "rgba(31, 199, 10, 0.52)",
  lime48: "rgba(31, 199, 10, 0.48)",
  lime44: "rgba(31, 199, 10, 0.44)",
  lime40: "rgba(31, 199, 10, 0.40)",
  lime36: "rgba(31, 199, 10, 0.36)",
  lime32: "rgba(31, 199, 10, 0.32)",
  lime28: "rgba(31, 199, 10, 0.28)",
  lime24: "rgba(31, 199, 10, 0.24)",
  lime20: "rgba(31, 199, 10, 0.20)",
  lime16: "rgba(31, 199, 10, 0.16)",
  lime12: "rgba(31, 199, 10, 0.12)",
  lime8: "rgba(31, 199, 10, 0.08)",
  lime4: "rgba(31, 199, 10, 0.04)",
  banana100: "rgba(254, 169, 13, 1)",
  banana96: "rgba(254, 169, 13, 0.96)",
  banana92: "rgba(254, 169, 13, 0.92)",
  banana88: "rgba(254, 169, 13, 0.88)",
  banana84: "rgba(254, 169, 13, 0.84)",
  banana80: "rgba(254, 169, 13, 0.80)",
  banana76: "rgba(254, 169, 13, 0.76)",
  banana72: "rgba(254, 169, 13, 0.72)",
  banana68: "rgba(254, 169, 13, 0.68)",
  banana64: "rgba(254, 169, 13, 0.64)",
  banana60: "rgba(254, 169, 13, 0.60)",
  banana56: "rgba(254, 169, 13, 0.56)",
  banana52: "rgba(254, 169, 13, 0.52)",
  banana48: "rgba(254, 169, 13, 0.48)",
  banana44: "rgba(254, 169, 13, 0.44)",
  banana40: "rgba(254, 169, 13, 0.40)",
  banana36: "rgba(254, 169, 13, 0.36)",
  banana32: "rgba(254, 169, 13, 0.32)",
  banana28: "rgba(254, 169, 13, 0.28)",
  banana24: "rgba(254, 169, 13, 0.24)",
  banana20: "rgba(254, 169, 13, 0.20)",
  banana16: "rgba(254, 169, 13, 0.16)",
  banana12: "rgba(254, 169, 13, 0.12)",
  banana8: "rgba(254, 169, 13, 0.08)",
  banana4: "rgba(254, 169, 13, 0.04)",
  orange100: "rgba(252, 98, 0, 1)",
  orange96: "rgba(252, 98, 0, 0.96)",
  orange92: "rgba(252, 98, 0, 0.92)",
  orange88: "rgba(252, 98, 0, 0.88)",
  orange84: "rgba(252, 98, 0, 0.84)",
  orange80: "rgba(252, 98, 0, 0.80)",
  orange76: "rgba(252, 98, 0, 0.76)",
  orange72: "rgba(252, 98, 0, 0.72)",
  orange68: "rgba(252, 98, 0, 0.68)",
  orange64: "rgba(252, 98, 0, 0.64)",
  orange60: "rgba(252, 98, 0, 0.60)",
  orange56: "rgba(252, 98, 0, 0.56)",
  orange52: "rgba(252, 98, 0, 0.52)",
  orange48: "rgba(252, 98, 0, 0.48)",
  orange44: "rgba(252, 98, 0, 0.44)",
  orange40: "rgba(252, 98, 0, 0.40)",
  orange36: "rgba(252, 98, 0, 0.36)",
  orange32: "rgba(252, 98, 0, 0.32)",
  orange28: "rgba(252, 98, 0, 0.28)",
  orange24: "rgba(252, 98, 0, 0.24)",
  orange20: "rgba(252, 98, 0, 0.20)",
  orange16: "rgba(252, 98, 0, 0.16)",
  orange12: "rgba(252, 98, 0, 0.12)",
  orange8: "rgba(252, 98, 0, 0.08)",
  orange4: "rgba(252, 98, 0, 0.04)",
  strawberry100: "rgba(249, 58, 37, 1)",
  strawberry96: "rgba(249, 58, 37, 0.96)",
  strawberry92: "rgba(249, 58, 37, 0.92)",
  strawberry88: "rgba(249, 58, 37, 0.88)",
  strawberry84: "rgba(249, 58, 37, 0.84)",
  strawberry80: "rgba(249, 58, 37, 0.80)",
  strawberry76: "rgba(249, 58, 37, 0.76)",
  strawberry72: "rgba(249, 58, 37, 0.72)",
  strawberry68: "rgba(249, 58, 37, 0.68)",
  strawberry64: "rgba(249, 58, 37, 0.64)",
  strawberry60: "rgba(249, 58, 37, 0.60)",
  strawberry56: "rgba(249, 58, 37, 0.56)",
  strawberry52: "rgba(249, 58, 37, 0.52)",
  strawberry48: "rgba(249, 58, 37, 0.48)",
  strawberry44: "rgba(249, 58, 37, 0.44)",
  strawberry40: "rgba(249, 58, 37, 0.40)",
  strawberry36: "rgba(249, 58, 37, 0.36)",
  strawberry32: "rgba(249, 58, 37, 0.32)",
  strawberry28: "rgba(249, 58, 37, 0.28)",
  strawberry24: "rgba(249, 58, 37, 0.24)",
  strawberry20: "rgba(249, 58, 37, 0.20)",
  strawberry16: "rgba(249, 58, 37, 0.16)",
  strawberry12: "rgba(249, 58, 37, 0.12)",
  strawberry8: "rgba(249, 58, 37, 0.08)",
  strawberry4: "rgba(249, 58, 37, 0.04)",
  plum100: "rgba(135, 29, 196, 1)",
  plum96: "rgba(135, 29, 196, 0.96)",
  plum92: "rgba(135, 29, 196, 0.92)",
  plum88: "rgba(135, 29, 196, 0.88)",
  plum84: "rgba(135, 29, 196, 0.84)",
  plum80: "rgba(135, 29, 196, 0.80)",
  plum76: "rgba(135, 29, 196, 0.76)",
  plum72: "rgba(135, 29, 196, 0.72)",
  plum68: "rgba(135, 29, 196, 0.68)",
  plum64: "rgba(135, 29, 196, 0.64)",
  plum60: "rgba(135, 29, 196, 0.60)",
  plum56: "rgba(135, 29, 196, 0.56)",
  plum52: "rgba(135, 29, 196, 0.52)",
  plum48: "rgba(135, 29, 196, 0.48)",
  plum44: "rgba(135, 29, 196, 0.44)",
  plum40: "rgba(135, 29, 196, 0.40)",
  plum36: "rgba(135, 29, 196, 0.36)",
  plum32: "rgba(135, 29, 196, 0.32)",
  plum28: "rgba(135, 29, 196, 0.28)",
  plum24: "rgba(135, 29, 196, 0.24)",
  plum20: "rgba(135, 29, 196, 0.20)",
  plum16: "rgba(135, 29, 196, 0.16)",
  plum12: "rgba(135, 29, 196, 0.12)",
  plum8: "rgba(135, 29, 196, 0.08)",
  plum4: "rgba(135, 29, 196, 0.04)"
};
Object.freeze(colors);
const semanticColors = {
  light: {
    /** @deprecated use `color.text` from `@creditornot/cb-ingredients/design-tokens` instead */
    textPrimary: colors.pepper100,
    /** @deprecated use `color.textSubdued` from `@creditornot/cb-ingredients/design-tokens` instead */
    textSecondary: colors.pepper64,
    /** @deprecated use `color.textDisabled` from `@creditornot/cb-ingredients/design-tokens` instead */
    textTertiary: colors.pepper40,
    /** @deprecated use `color.bg` from `@creditornot/cb-ingredients/design-tokens` instead */
    surfaceMain: colors.salt100,
    /** @deprecated use `color.border` from `@creditornot/cb-ingredients/design-tokens` instead */
    borderPrimary: colors.pepper12,
    /** @deprecated use `color.border` from `@creditornot/cb-ingredients/design-tokens` instead */
    borderLight: colors.pepper12,
    /** @deprecated use `color.outlineFocused` from `@creditornot/cb-ingredients/design-tokens` instead */
    a11yFocusIndicator: colors.nightSky100
  },
  lightHighContrast: {
    /** @deprecated use `color.text` from `@creditornot/cb-ingredients/design-tokens` instead */
    textPrimary: colors.pepper100,
    /** @deprecated use `color.textSubdued` from `@creditornot/cb-ingredients/design-tokens` instead */
    textSecondary: colors.pepper80,
    /** @deprecated use `color.textDisabled` from `@creditornot/cb-ingredients/design-tokens` instead */
    textTertiary: colors.pepper80,
    /** @deprecated use `color.bg` from `@creditornot/cb-ingredients/design-tokens` instead */
    surfaceMain: colors.salt100,
    /** @deprecated use `color.border` from `@creditornot/cb-ingredients/design-tokens` instead */
    borderPrimary: colors.pepper80,
    /** @deprecated use `color.border` from `@creditornot/cb-ingredients/design-tokens` instead */
    borderLight: colors.pepper80,
    /** @deprecated use `color.outlineFocused` from `@creditornot/cb-ingredients/design-tokens` instead */
    a11yFocusIndicator: colors.nightSky100
  },
  dark: {
    /** @deprecated use `color.text` from `@creditornot/cb-ingredients/design-tokens` instead */
    textPrimary: colors.salt100,
    /** @deprecated use `color.textSubdued` from `@creditornot/cb-ingredients/design-tokens` instead */
    textSecondary: colors.salt72,
    /** @deprecated use `color.textDisabled` from `@creditornot/cb-ingredients/design-tokens` instead */
    textTertiary: colors.salt48,
    /** @deprecated use `color.bg` from `@creditornot/cb-ingredients/design-tokens` instead */
    surfaceMain: "#141414",
    /** @deprecated use `color.border` from `@creditornot/cb-ingredients/design-tokens` instead */
    borderPrimary: colors.salt16,
    /** @deprecated use `color.border` from `@creditornot/cb-ingredients/design-tokens` instead */
    borderLight: colors.salt16,
    /** @deprecated use `color.outlineFocused` from `@creditornot/cb-ingredients/design-tokens` instead */
    a11yFocusIndicator: colors.banana100
  }
};
Object.freeze(semanticColors);
const fallbacks = {
  borderLight: "borderPrimary",
  borderPrimary: "borderLight"
};
const createVarName = (key) => `--cb-color-${key}`;
const cbSemanticCssVars = Object.fromEntries(Object.keys(semanticColors.light).map((key) => {
  const fallbackKey = fallbacks[key];
  return [key, `var(${createVarName(key)}${fallbackKey ? `, var(${createVarName(fallbackKey)})` : ""})`];
}));
const elevationXsmall = "cb_elevation_elevationXsmall_equ2";
const elevationSmall = "cb_elevation_elevationSmall_e1vr";
const elevationMedium = "cb_elevation_elevationMedium_e16y";
const elevationLarge = "cb_elevation_elevationLarge_eg61";
const ELEVATED_CONTAINER_CLASSNAME = "cb-elevated";
const elevationClassName = {
  xsmall: `${ELEVATED_CONTAINER_CLASSNAME} ${elevationXsmall}`,
  small: `${ELEVATED_CONTAINER_CLASSNAME} ${elevationSmall}`,
  medium: `${ELEVATED_CONTAINER_CLASSNAME} ${elevationMedium}`,
  large: `${ELEVATED_CONTAINER_CLASSNAME} ${elevationLarge}`
};
const darkModeElevationBGColors = {
  0: "#171717",
  1: "#181818",
  2: "#191919",
  3: "#191919",
  4: "#1C1C1C",
  6: "#1F1F1F",
  8: "#212121",
  12: "#242424",
  16: "#262626",
  24: "#303030"
};
Object.freeze(darkModeElevationBGColors);
const elevationCss = (level) => {
  const backgroundElevation = typeof level === "object" ? {
    light: level.light,
    dark: level.dark.backgroundElevation
  } : {
    light: level,
    dark: level
  };
  const shadowElevation = typeof level === "object" ? {
    light: level.light,
    dark: level.dark.shadowElevation
  } : {
    light: level,
    dark: level
  };
  const bgCss = `
    ${createThemedCssVarDefinitions({
    backgroundElevated: {
      light: colors.salt100,
      lightHighContrast: colors.salt100,
      dark: darkModeElevationBGColors[backgroundElevation.dark]
    }
  })}

    background-color: var(--backgroundElevated);
  `;
  if (shadowElevation.light === 0 && shadowElevation.dark === 0) {
    return bgCss;
  }
  return `
    ${bgCss}

    ${createThemedCssVarDefinitions({
    boxShadowElevated: {
      light: `0 0 ${pxToRem(shadowElevation.light)} 0 rgba(0, 0, 0, 0.06),
          0 ${pxToRem(shadowElevation.light)} ${pxToRem(shadowElevation.light)} 0 rgba(0, 0, 0, 0.12)`,
      lightHighContrast: `0 0 ${pxToRem(shadowElevation.light)} 0 rgba(0, 0, 0, 0.8),
          0 ${pxToRem(shadowElevation.light)} ${pxToRem(shadowElevation.light)} 0 rgba(0, 0, 0, 0.12)`,
      dark: `0 0 ${pxToRem(shadowElevation.dark)} 0 rgba(0, 0, 0, 0.06),
          0 ${pxToRem(shadowElevation.dark)} ${pxToRem(shadowElevation.dark)} 0 rgba(0, 0, 0, 0.12)`
    }
  })}

    box-shadow: var(--boxShadowElevated);
  `;
};
const WoltLogo = /* @__PURE__ */ React.forwardRef((props, ref) => /* @__PURE__ */ jsx("svg", {
  viewBox: "0 0 720 262",
  ...props,
  ref,
  children: /* @__PURE__ */ jsx("path", {
    d: "M411.996 159.402c-12.655-9.343-18.116-26.236-13.633-52.765.14-.84.502-2.324.98-4.138-2.635-1.049-5.617-1.498-8.976-1.498-29.86 0-46.485 50.303-46.485 97.062 0 24.374 9.528 36.655 23.763 36.655 19.738 0 37.879-34.26 44.351-75.316m246.149-47.158s-14.268 68.612-14.268 93.99c0 17.638 8.218 23.682 18.37 23.682 12.837 0 24.623-8.102 35.6-28.21 2.52-4.615 11.736-1.727 16.57 3.835 2.106 2.426-.318 7.317-3.638 12.913C694.144 246.502 670.643 262 646.225 262c-26.6 0-42.953-12.398-47.05-43.758C583.917 242.244 559.498 262 531.516 262c-34.02 0-48.5-18.827-48.5-52.607 0-22.281 7.505-60.23 7.505-60.23-9.966 8.981-21.522 15.475-34.824 18.172C442.624 228.594 407.632 262 360.613 262c-39.819 0-67.176-20.926-67.176-71.113 0-61.952 39.45-117.15 101.346-117.15 35.243 0 60.825 18.91 63.078 62.92 14.492-2.446 27.884-12.369 39.545-26.498 5.248-33.237 12.748-71.145 17.325-92.536.953-4.45 2.579-12.797 10.504-15.267 8.87-2.768 21.537-3.256 34.857-.608 7.384 1.467 9.261 8.367 9.261 14.533 0 16.397-7.769 52.57-21.278 85.1-9.574 36.262-16.142 72.442-16.142 101.05 0 20.673 6.84 27.485 18.309 27.485 18.72 0 40.466-26.001 50.939-61.226 1.626-16.944 5.916-44.198 8.068-54.357-11.597.557-19.01.894-19.01.894-6.034.221-11.883-2.323-11.586-7.71.394-7.096 1.37-13.925 2.565-18.734 1.196-4.809 3.938-7.793 9.768-7.896 6.255-.11 15.25-.037 24.516.185 3.122-17.875 5.746-31.825 8.266-43.421 1.007-4.641 5.35-7.313 9.82-7.815 5.35-.6 21.291-.487 28.23 1.196 6.986 1.698 9.913 7.185 8.702 12.735-2.472 11.303-7.526 39.04-7.526 39.04a6147.07 6147.07 0 0 1 46.66 2.252c7.475.335 11.327 4.544 10.131 11.125-2.016 11.055-10.246 14.608-21.875 14.875-13.262.304-27.21.731-39.765 1.185M299.32 23.772c0 77.229-41.424 237.729-105.603 237.729-48.42 0-58.144-54.148-60.644-123.13-24.267 52.943-37.112 80.43-53.148 107.952C72.35 259.32 63.246 262 53.302 262c-8.757 0-31.342-2.926-36.603-6.19-5.261-3.262-8.153-6.21-10.73-18.68-11.925-57.698-4.212-132.317 7.642-191.802 2.071-10.393 4.737-15.415 11.917-20.121 7.659-5.019 24.632-5.373 35.686-5.566 5.868-.103 9.279 4.121 7.803 11.274-10.677 51.94-23.21 123.105-13.445 196.466 0 0 36.936-73.192 75.224-164.314 7.685-18.291 9.405-24.297 16.715-25.917 9.568-2.12 16.467-2.13 26.102-.959 6.357.774 9.553 2.432 9.309 11.24-.667 23.745-2.257 50.615-2.257 78.511 0 47.204 5.064 100.27 23.246 100.27 24.419 0 45.87-113.537 38.294-211.097-.524-6.738 1.912-13.583 9.113-14.33C254.925.412 262.227 0 270.457 0c18.748 0 28.864 3.343 28.864 23.772"
  })
}));
const WoltLogo$1 = WoltLogo;
const legacyTypographyClassName = legacyTypographyClassNameAlias;
export {
  ELEVATED_CONTAINER_CLASSNAME,
  WoltLogo$1 as WoltLogo,
  cbSemanticCssVars,
  colors,
  darkModeElevationBGColors,
  elevationClassName,
  elevationCss,
  legacyConsumerTypographyCss,
  legacyToolsTypographyCss,
  legacyTypographyClassName,
  mediaQuery,
  semanticColors,
  typographyClassName,
  typographyCss,
  viewportWidth
};
//# sourceMappingURL=index.js.map
